export enum ChangeRequestModalTypes {
    CREATE = "CREATE",
    CANCEL = "CANCEL",
    SUBMIT = "SUBMIT",
    UNSUBMIT = "UNSUBMIT",
    APPROVE = "APPROVE",
    REJECT = "REJECT",
    DEPLOY_NOW = "DEPLOY_NOW"
}